import { Injectable, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { IAppConfig } from './app-config.interface';
import { environment } from './../environments/environment';
import { EMPTY, catchError } from 'rxjs';
import { AppConst } from '@shared/app-const';

export const APP_CONFIG = new InjectionToken<IAppConfig>('app_config');
@Injectable({ providedIn: 'root' })
export class AppConfigService {

  public static config: IAppConfig;
  public static srcImagens:string = '/wwwroot/financeiro-front/assets/icones-bancos/';

  constructor(private http: HttpClient) {
    if((window as any).appConfig)
      AppConfigService.config = (window as any).appConfig

    const appConfig = JSON.parse(localStorage.getItem(AppConst.KEY_CONFIG) || 'null');
    if(appConfig !== null)
      AppConfigService.srcImagens = '/FrameHTML/web/app/Fin/Financeiro-front/assets/icones-bancos/';
  }

  protected httpOptionsNoToken(params?: HttpParams): object {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'X-No-Token': 'true', 'X-No-Alias': 'true', 'X-PO-No-Error': 'true' }),
      withCredentials: false
    };
  }

  carregarConfiguracoes() {
    const arquivoConfiguracao = `./config/config.json`;
    this.http.get<IAppConfig>(arquivoConfiguracao, this.httpOptionsNoToken())
      .pipe(catchError((erro: any) => {
        return EMPTY;
      }))
      .subscribe((resposta: IAppConfig) => {
        AppConfigService.config = resposta;
        if (!environment.production)
          AppConfigService.config = this.carregaVariaveisDeDesenvolvimento();

        if (!AppConfigService.config.apiServer)
          AppConfigService.config.apiServer = `${location.protocol}//${location.host}${location.pathname}`;

      });
  }

  carregaVariaveisDeDesenvolvimento(): IAppConfig {
    return {
      apiServer: environment.apiServer,
      basePath: environment.basePath
    } as IAppConfig;
  }

  retornaApiServer() {
    return AppConfigService.config.apiServer;
  }
}
